<template>
  <div>
    <Mainl @mlogin="mlogin" @scrollTo="scrollTo"></Mainl>
    <div class="page_content">
      <div class="service_case_content">
        <div class="service_case_title">
          <div class="service_case_title_text">案例库<span>共{{caseCount}}个案例</span></div>
          <div class="service_case_search">
            <div class="case_list_search_wrap">
              <img class="search_icon" :src="require('@/assets/img/icon_search.png')"/>
              <el-input  popper-class="search_popper_class" size="small" clearable @clear="initList()" class="search_input" v-model="form.name" placeholder="请输入案例名称"></el-input>
              <div class="case_list_search_btn" @click="initList">搜索</div>
            </div>
            <el-button style="height: 32px;padding: 6px 24px;margin-left: 24px;" type="primary" @click="addCase">上传案例</el-button>
          </div>
        </div>
        <div  class="case_list_select_option">
          <span :class="form.category_key === '' ? 'case_list_select_active' : ''" @click="checkCategoryKey('')">全部</span>
          <span :class="form.category_key === item.Key ? 'case_list_select_active' : ''" :key="key" v-for="(item, key) in top_creative_categories_dict"  @click="checkCategoryKey(item.Key)" >{{item.Value}}</span>
        </div>
        <div v-if="caseList.length > 0" class="case_card_list">
          <div v-for="(item, key) in caseList" class="case_card_list_item" :key="key" @click="goDetail(item)">
            <span class="case_card_list_item_status case_card_list_item_status_1">待审核</span>
            <span class="case_card_list_item_status" :class="'case_card_list_item_status_' + item.review_status">{{ status_dic[item.review_status] }}</span>
            <img :src="item.cover_url" />
            <!-- <el-image  :src="item.cover_url" lazy></el-image> -->
            <div class="case_card_list_item_content">
              <span>{{ item.name }}</span>
              <span>{{item.create_time_str}}</span>
            </div>
          </div>
        </div>
        <div v-else class="service_case_card_list_no_data" @click="addCase">
          <i class="el-icon-circle-plus"></i>
          <span>赶快添加一个案例吧</span>
        </div>
        <div v-show="caseList.length > 0" class="case_list_page">
          <div class="pagination_wrap">
            <!-- hide-on-single-page -->
            <el-pagination
                background
                layout="prev, pager, next"
                :total="caseCount"
                :current-page="currentPage"
                :page-size="pageSize"
                @current-change="handlePageChange"
            >
            </el-pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import Mainl from '@/components/Mainl.vue'
// import axios from 'axios'
// import Cookies from 'js-cookie'
// eslint-disable-next-line
import * as commfun from '@/common/common.js'
import Cookies from 'js-cookie'
var pubPrefix = '/api'
export default {
  name: 'ServiceCaseList',
  components: {
    Mainl
  },
  data: function () {
    return {
      form: {
        name: '',
        category_key: ''
      },
      caseList: [],
      xy_case_money_dict: [], // 项目金额字典
      industry_dic: [], // 所属行业字典
      category_dic: [], // 创意类目字典
      top_creative_categories_dict: [], // 单一级创意类目字典
      caseCount: 0,
      currentPage: 1,
      pageSize: 18, // 每页数量
      status_dic: {1: '待审核', 2: '已通过', 3: '未通过'}
    }
  },
  created () {
    // 获取字典数据
    this.getDict()
  },
  mounted () {
    this.initList()
  },
  methods: {
    // 获取字典
    getDict () {
      var selfthis = this
      var url = pubPrefix + '/api/case/dict'
      commfun.ajaxGet(selfthis, url, {}, function (selfthis, result) {
        selfthis.xy_case_money_dict = result.xy_case_money_dict
        selfthis.industry_dic = result.industry_dic
        selfthis.category_dic = result.category_dic
        selfthis.top_creative_categories_dict = result.top_creative_categories_dict
      }, function (selfthis, result) {
        selfthis.$message({
          showClose: true,
          message: '字典查询错误，请联系管理员！',
          type: 'warning',
          customClass: 'zZindex'
        })
      })
    },
    // 列表数据
    initList: function () {
      var selfthis = this
      var url = pubPrefix + '/api/case/caseList'
      var postdata={
        category_key: this.form.category_key,
        name:this.form.name,
        pageSize:this.pageSize,
        currentPage:this.currentPage,
        look_type: 2  // 1:需求方  2:服务方
      }
      commfun.ajaxPost(selfthis, url, postdata, function (selfthis, data) {
        if (data == null || data === undefined) {
          selfthis.caseList = []
          selfthis.caseCount = 0
        } else {
          selfthis.caseList = data.data
          selfthis.caseCount = data.count
        }
      }, function (selfthis, dataError) {
        commfun.showMessage(selfthis, 'warning', '错误：' + dataError.msg)
      })
    },
    // 切换页码
    handlePageChange(currentPage) {
      // 处理页码变化回调，更新 currentPage 并重新获取数据
      this.currentPage = currentPage;
      this.initList();
    },
    // 一级创意类目选择
    checkCategoryKey (val) {
      this.form.category_key = val
      this.initList()
    },
    // 案例详情
    goDetail (item) {
      window.open('/servicecasedetail?case_id=' + item.case_id)
    },
    // 添加案例
    addCase () {
      window.location.href = '/servicecaseadd'  // 让改为当前页面打开
      // window.open('/servicecaseadd')
    },
    mlogin: function (type) {
      if (type === 'example') {
        this.visible = true
      } else {
        this.visible2 = true
      }
    },
    scrollTo: function (type) { // 滚动到位置 锚点
      document.querySelector('#' + type).scrollIntoView(true)
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ServiceCaseList.vue